module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', [_c('authorized-link', {
    attrs: {
      "tag": "create_user"
    }
  }, [_c('router-link', {
    staticClass: "ls-btn-primary ls-no-margin ls-float-right",
    attrs: {
      "to": {
        name: 'new_user'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('access_users.main.buttons.new')))])], 1), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('div', [(_vm.accessUsers && _vm.accessUsers.length) ? _c('table', {
    staticClass: "ls-table ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('access_users.attributes.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('access_users.attributes.email')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.accessUsers), function(user, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ls-float-right"
    }, [_c('authorized-link', {
      staticClass: "ls-float-right",
      attrs: {
        "tag": "destroy_user"
      }
    }, [(_vm.currentUser.id != user.id) ? _c('button', {
      staticClass: "ls-btn-danger",
      on: {
        "click": function($event) {
          _vm.deleteUser(user, index)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e()]), _vm._v(" "), _c('authorized-link', {
      staticClass: "ls-float-right",
      attrs: {
        "tag": "update_user"
      }
    }, [_c('div', {
      staticClass: "ls-float-right"
    }, [_c('router-link', {
      staticClass: "ls-btn",
      attrs: {
        "to": {
          name: 'edit_user',
          params: {
            id: user.id
          }
        }
      },
      slot: "button"
    }, [_vm._v(_vm._s(_vm.$t('application.button.edit')))])], 1)])], 1)])])
  }))]) : _c('div', {
    attrs: {
      "role": "alert"
    }
  }, [_c('empty-list')], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "updater": _vm.getAccessUsers
    }
  }), _vm._v(" "), _c('modal-destroy', {
    model: {
      value: (_vm.destroyObject),
      callback: function($$v) {
        _vm.destroyObject = $$v
      },
      expression: "destroyObject"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a1d64e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/access_users/Main.vue
// module id = 754
// module chunks = 1